// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
var _ = require('lodash');
import {
  GET_TWIGS, UPDATE_CHART, CHANGE_DISPLAYOPTION, CHANGE_DEPTHOPTION, CHANGE_TWIG,
  UPDATE_TODATE, UPDATE_FROMDATE, CHANGE_RESOULTION, UPDATE_SELECTEDTWIG, CHANGE_TREND_AVERAGE,
  SHOW_TRENDLINE, SHOW_RAWGRAPH, TOGGLE_LOWERLIMIT, TOGGLE_UPPERLIMIT, GET_ALERTS, RESET_CHART, CLEAR_TWIGS, SESSION_LOGOUT, GET_USER_PREFERENCES, TOGGLE_ZOOM, UPDATE_DATE_RANGE, GET_STRIPEPLANS, ADD_SUBSCRPTION, CONFIRM_SUBSCRIPTION, VALIDATE_COUPON, GET_SUBSCRIPTION_HISTORY, SHOW_CHART_VIEW, HANDLE_PAYMENT_INFO_SUBMIT, INIT_PAYMENT_INFO,REMEMBER_ME, REBIND_COUPON_DATA
} from '../actions/actions';
import constants from '../Constants';
import {
  filterChart, getFromSession, saveInSession, loadTwigDataBasedonPreference,
  convertDate, getInitialFromDate, getSelectedTwigDetails
} from '../utils/Utility';
let selectedTwigFromSession = getFromSession('selectedTwig');
const initialState = {
  twigsList: [],
  selectedTwig: selectedTwigFromSession ? selectedTwigFromSession : '',
  selectedTwigIndex: 0,
  chartData: null,
  resolution: 1,
  showRawGraph: true,
  showTrendLine: true,
  trendAverage: 20,
  showLowerLimit: false,
  showUpperLimit: false,
  userPreferences: [],
  dateRange: { type: constants.DATE_RANGE.TWO_WEEKS, fromDate: getInitialFromDate(), toDate: '' },
  chartOptions: {
    DisplayOptions: {},
    depth: {
      [constants.CHART_OPTIONS.TOP]: true,
      [constants.CHART_OPTIONS.MIDDLE]: true,
      [constants.CHART_OPTIONS.BOTTOM]: true
    },
    dateRange: constants.DATE_RANGE.TWO_WEEKS,
    fromDate: getInitialFromDate(),
    toDate: new Date(),
    showChart: true
  },
  alerts: [],
  zoom: false,
  showStripePlans: false,
  showSubscriptionForm: false, 
  showConfirmationDialog : false,
  showError : false,
  selectedPlan: null,
  couponDetails: null,
  subscriptionCreated : null,
  subscription: null,
  paymentInformation : null,
  rememberMe: false,
  cardInfo : null,
  couponData: ''
};
let _chartData = null;
let _chartOptions = {
  displayOptions: {},
  depth: {
    [constants.CHART_OPTIONS.TOP]: true,
    [constants.CHART_OPTIONS.MIDDLE]: true,
    [constants.CHART_OPTIONS.BOTTOM]: true
  },
  dateRange: constants.DATE_RANGE.ALL,
  fromDate: '',
  endDate: ''
}
const handlers = {

  [GET_TWIGS]: (state, action) => {

    if (action.result && action.result.length > 0) {
      let selectedTwig = action.result[action.selectedIndex]
      _chartOptions.displayOptions = {};
      let showChart = false;
      if (selectedTwig && selectedTwig.details) {
        showChart = true;
        _.sortBy(selectedTwig.details.data, [function (o) { return o.sort_order; }]);
        Object.keys(selectedTwig.details.data).map((key, index) => {
          _chartOptions.displayOptions[key] = true;
        });
      }
      // sessionStorage.selectedTwig = {};
      saveInSession('selectedTwig', selectedTwig);

      return {
        twigsList: action.result,
        selectedTwig: selectedTwig,
        selectedTwigIndex: action.selectedIndex,
        showChart: showChart
      };
    } else {
      _chartOptions.displayOptions = {};
      sessionStorage.removeItem('selectedTwig')
      return {
        twigsList: [],
        selectedTwig: '',
        selectedTwigIndex: 0,
        showChart: false
      };
    }
  },
  [CLEAR_TWIGS]: (state, action) => {
    return {
      twigsList: [],
      selectedTwig: '',
      selectedTwigIndex: 0,
      showChart: false
    };
  },
  [UPDATE_SELECTEDTWIG]: (state, action) => {
    let selectedTwig = state.twigsList[action.index];
    let showChart = false;

    if (selectedTwig.details) {
      showChart = true;
      _.sortBy(selectedTwig.details.data, [function (o) { return o.sort_order; }]);
      Object.keys(selectedTwig.details.data).map((key, index) => {
        _chartOptions.displayOptions[key] = true;
      });
    }
    saveInSession('selectedTwig', selectedTwig);
    return {
      selectedTwig: selectedTwig,
      selectedTwigIndex: action.index,
      showChart: showChart
    };
  },
  [UPDATE_CHART]: (state, action) => {
    _chartData = _.cloneDeep(action.result);
    let chartData = _.cloneDeep(_chartData);
    let chartOption = _.cloneDeep(state.chartOptions);
    if (chartData && chartData != 'loading') {
      let displayOptions = {};
      if (_chartOptions.DisplayOptions) {
        displayOptions = _.cloneDeep(_chartOptions.DisplayOptions);
      } else if (_chartOptions.displayOptions) {
        displayOptions = _.cloneDeep(_chartOptions.displayOptions);
      }

      if (Object.keys(displayOptions).length === 0) {
        _chartOptions.DisplayOptions = getSelectedTwigDetails(state.twigsList[0].twigId, state.twigsList);
        _chartOptions.displayOptions = _.cloneDeep(_chartOptions.DisplayOptions);
      }

      if (Object.keys(chartData).length > 0) {
        chartData = filterChart(chartData, _chartOptions);
      }
      chartOption.DisplayOptions = _chartOptions.displayOptions;
    }
    return {
      chartData: chartData,
      chartOptions: chartOption
    };
  },
  [CHANGE_DISPLAYOPTION]: (state, action) => {
    let chartData = _.cloneDeep(_chartData);
    _chartOptions.displayOptions[action.result.key] = action.result.value;
    chartData = filterChart(chartData, _chartOptions);
    return {
      chartData: chartData,
      chartOptions: _chartOptions
    };
  },
  [CHANGE_DEPTHOPTION]: (state, action) => {
    let chartData = _.cloneDeep(_chartData);
    let depth = _.cloneDeep(state.chartOptions.depth);
    _chartOptions.depth = depth;
    _chartOptions.depth[action.result.key] = action.result.value;
    chartData = filterChart(chartData, _chartOptions);
    return {
      chartData: chartData,
      chartOptions: _chartOptions
    };
  },
  [TOGGLE_LOWERLIMIT]: (state, action) => {
    return {
      showLowerLimit: action.result
    };
  },
  [TOGGLE_UPPERLIMIT]: (state, action) => {
    return {
      showUpperLimit: action.result
    };
  },
  [CHANGE_TWIG]: (state, action) => {

    let selectedTwig = state.twigsList[action.result];
    _chartOptions.displayOptions = {};
    _.sortBy(selectedTwig.details.data, [function (o) { return o.sort_order; }]);
    Object.keys(selectedTwig.details.data).map((key, index) => {
      _chartOptions.displayOptions[key] = true;
    });
    saveInSession('selectedTwig', selectedTwig);
    return {
      selectedTwig: selectedTwig
    };
  },
  [UPDATE_FROMDATE]: (state, action) => {
    let chartOptions = _.cloneDeep(state.chartOptions);
    chartOptions.fromDate = action.result;
    return {
      chartOptions: chartOptions
    };
  },
  [UPDATE_TODATE]: (state, action) => {
    let chartOptions = _.cloneDeep(state.chartOptions);
    chartOptions.toDate = action.result;
    return {
      chartOptions: chartOptions
    };
  },
  [UPDATE_DATE_RANGE]: (state, action) => {
    let chartOptions = _.cloneDeep(state.chartOptions);
    chartOptions.dateRange = action.result;
    return {
      chartOptions: chartOptions
    };
  },
  [CHANGE_RESOULTION]: (state, action) => {
    return {
      resolution: action.result
    };
  },
  [SHOW_TRENDLINE]: (state, action) => {
    return {
      showTrendLine: action.result
    };
  },
  [SHOW_RAWGRAPH]: (state, action) => {
    return {
      showRawGraph: action.result
    };
  },
  [CHANGE_TREND_AVERAGE]: (state, action) => {
    return {
      trendAverage: action.result
    };
  },
  /******** */
  [GET_ALERTS]: (state, action) => {
    return {
      alerts: action.result
    }
  },
  [SESSION_LOGOUT]: (state, action) => {
    // let position = _.cloneDeep(state.position);
    return initialState;
  },
  [GET_USER_PREFERENCES]: (state, action) => {
    let chartOptions = _.cloneDeep(state.chartOptions);
    let prefData = loadTwigDataBasedonPreference(state, action.result);
    chartOptions.dateRange = prefData.DateRange.type;
    chartOptions.toDate = (prefData.DateRange.toDate);
    chartOptions.fromDate = (prefData.DateRange.fromDate);
    chartOptions.depth = prefData.Depth;

    _chartOptions.dateRange = prefData.DateRange.type;
    _chartOptions.toDate = (prefData.DateRange.toDate);
    _chartOptions.fromDate = (prefData.DateRange.fromDate);
    _chartOptions.depth = prefData.Depth;

    if (action.result.UserPref.preference.sensors) {
      _chartOptions.displayOptions = action.result.UserPref.preference.sensors;
      chartOptions.DisplayOptions = action.result.UserPref.preference.sensors;
      chartOptions.displayOptions = action.result.UserPref.preference.sensors;
    } else {
      let dOption = getSelectedTwigDetails(action.result.UserPref.preference.stem, state.twigsList);
      chartOptions.DisplayOptions = dOption;
      chartOptions.displayOptions = dOption;
      _chartOptions.displayOptions = dOption;
    }

    let chartData = _.cloneDeep(action.result.chartData);
    _chartData = _.cloneDeep(chartData);
    if (chartData && chartData != 'loading' && Object.keys(chartData).length > 0) {
      chartData = filterChart(chartData, chartOptions);
    }

    return {
      userPreferences: action.result.UserPref,
      selectedTwig: prefData.selectedTwig,
      selectedTwigIndex: prefData.twigIndex,
      chartOptions: chartOptions,
      trendAverage: action.result.UserPref.preference.dataModel.trendAverage,
      showRawGraph: action.result.UserPref.preference.dataModel.raw,
      showTrendLine: action.result.UserPref.preference.dataModel.trend,
      chartData: chartData,
      showLowerLimit: action.result.UserPref.preference.limits.lower,
      showUpperLimit: action.result.UserPref.preference.limits.upper,
      zoom: action.result.UserPref.preference.zoom,
      subscription: action.result.subscription
    }
  },
  [TOGGLE_ZOOM]: (state, action) => {
    return {
      zoom: action.result
    }
  },

  [GET_STRIPEPLANS]:(state, action) => {
    return {
      stripePlans: action.result.stripePlans,
      showStripePlans : action.result.success,
      showSubscriptionForm : !action.result.success,
      selectedPlan : null,
      rememberMe : null,
      savedCard : null,
      couponData : '',
      couponDetails : null
    }
  },

  [ADD_SUBSCRPTION]: (state, action) => {
    return {
      showSubscriptionForm : action.result.togglesubscriptionForm,
      selectedPlan: action.result.plan,
      rememberMe : action.result.rememberMe,
      savedCard : action.result.savedCard,
      couponData : '',
      couponDetails : null
    }
  },

  [CONFIRM_SUBSCRIPTION] :(state, action) => {
    return {
      showConfirmationDialog: action.result.success,
      subscriptionCreated : action.result.subscriptionCreated
    }
  },

  [VALIDATE_COUPON] : (state, action) => {
    return {
      couponDetails : action.result
    }
  },

  [SHOW_CHART_VIEW] : (state, action) => {
    return {
      showSubscriptionForm : action.result.showSubscriptionForm,
      showStripePlans: action.result.showStripePlans
    }
  },

  [HANDLE_PAYMENT_INFO_SUBMIT] : (state, action) => {
    return {
      showConfirmationDialog: action.result.showConfirmationDialog,
      showError : action.result.showError,
    }
  },

  [INIT_PAYMENT_INFO] : (state, action) => {
    return {
      paymentInformation: action.result
    }
  },

  [REMEMBER_ME] : (state, action) => {
    return  {
      rememberMe : action.result,
      savedCard : null
    }
  },

  [REBIND_COUPON_DATA] : (state, action) => {
    return {
      couponData : action.result
    }
  }

};

export default function locationViewReducer(state = initialState, action) {

  let handler = handlers[action.type];
  if (!handler) return state;
  let newState = _.cloneDeep(state);
  return { ...newState, ...handler(newState, action) };
}



// WEBPACK FOOTER //
// ./src/js/reducers/locationView.js